// extracted by mini-css-extract-plugin
export default {"ellipsis":"HomeRecentSearch-module__ellipsis___Rozj8","bg":"HomeRecentSearch-module__bg___NdR_8"};